import React from 'react';
export function Fabric() {
  return <div className="bg-white min-h-screen pt-32 pb-20 px-6" data-id="element-340">
      <div className="max-w-[1800px] mx-auto" data-id="element-341">
        <header className="mb-20 text-center" data-id="element-342">
          <span className="text-[10px] font-display uppercase tracking-[0.5em] mb-4 block text-black/40" data-id="element-343">
            The Raw Material
          </span>
          <h1 className="text-4xl md:text-6xl font-display font-bold tracking-[0.2em] uppercase mb-6" data-id="element-344">
            Fabric
          </h1>
          <p className="max-w-xl mx-auto text-sm font-light tracking-widest text-black/60 leading-relaxed uppercase" data-id="element-345">
            Authentic hand-woven Kente, Ankara prints, and luxury silks by the
            yard.
          </p>
        </header>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-1" data-id="element-346">
          <div className="aspect-video bg-grey-divider overflow-hidden" data-id="element-347">
            <img src="https://images.unsplash.com/photo-1523381210434-271e8be1f52b?auto=format&fit=crop&q=80&w=1200" className="w-full h-full object-cover" alt="Fabric" data-id="element-348" />
          </div>
          <div className="aspect-video bg-grey-divider overflow-hidden" data-id="element-349">
            <img src="https://images.unsplash.com/photo-1598554747436-c9293d6a588f?auto=format&fit=crop&q=80&w=1200" className="w-full h-full object-cover" alt="Fabric" data-id="element-350" />
          </div>
        </div>
      </div>
    </div>;
}